import type { ClientToServerLocationEvent, Location } from "@repo/contracts/events";
import { toast } from "react-toastify";
import type { Socket } from "socket.io-client";
import { io } from "socket.io-client";

export type { Location };

const baseURL = import.meta.env.VITE_APP_API_BASE_URL;
export class WebSocketSingleton {
  private static instance: WebSocketSingleton;
  private socket: Socket;
  connected = false;
  usersInDelivery = new Map<string, []>([]);
  constructor() {
    this.socket = io(`${baseURL}location`, {
      autoConnect: false,
      transports: ["websocket", "polling"],
      reconnectionDelay: 10000, // defaults to 1000
      reconnectionDelayMax: 10000, // defaults to 5000
    });

    this.socket.on("connect", () => {
      this.connected = true;
      toast("connected to live tracking", {
        position: "bottom-right",
        type: "info",
      });
    });
    this.socket.on("disconnect", () => {
      this.connected = false;
      toast("disconnected from sockets", {
        position: "bottom-right",
        type: "warning",
      });
    });
    this.socket.on("connect_error", (_error) => {
      toast("disconnected from sockets", {
        position: "bottom-right",
        type: "error",
      });
      this.connected = false;
    });

    this.socket.on("reconnect", () => {
      this.connected = true;
    });
  }

  static getInstance(): WebSocketSingleton {
    if (!WebSocketSingleton.instance) {
      WebSocketSingleton.instance = new WebSocketSingleton();
    }
    return WebSocketSingleton.instance;
  }

  async connect(_token?: string) {
    if (this.connected) {
      return;
    }
    const token = _token || localStorage.getItem("AccessToken");
    this.socket.auth = { token };
    this.socket.connect();
  }

  async close() {
    this.socket.disconnect();
  }

  joinRoom(deliveryId: number, handler?: (response: unknown) => void) {
    this.socket.emit("join-delivery", { deliveryId }, (res: unknown) => {
      handler?.(res);
    });
  }

  leaveRoom(deliveryId: number, handler?: (response: any) => void) {
    this.socket.emit("leave-delivery", { deliveryId }, handler);
  }

  sendLocation(data: ClientToServerLocationEvent, handler: (response: unknown) => void) {
    this.socket.emit("sendLocation", data, handler);
  }

  // * listeners
  onLocation(handler: (data: Location) => void) {
    this.socket.on("location", handler);
  }

  onAdminUpdate(handler: (data: any) => void) {
    this.socket.on("update-admin", (data) => {
      handler(data);
    });
  }

  onDriverUpdate(handler: (data: any) => void) {
    this.socket.on("update-driver", (data) => {
      handler(data);
    });
  }

  onPartnerUpdate(handler: (data: any) => void) {
    this.socket.on("update-partner", (data) => {
      handler(data);
    });
  }

  onOnliveDriversUpdate(handler: (data: any) => void) {
    this.socket.on("online-drivers", (data) => {
      handler(data);
    });
  }

  // get users

  // getDrivers() {
  //     let drivers = []
  //     this.usersInDeliveris.forEach((key, value) => {
  //         if (value.role === UserRole.DRIVER) {
  //             drivers.push(value)
  //         }
  //     })
  //     return drivers
  // }
  // getConnectedDrivers() {
  //     let drivers = []
  //     this.usersInDeliveris.forEach((key, value) => {
  //         if (value.role === UserRole.DRIVER && value.connected) {
  //             drivers.push(value)
  //         }
  //     })
  //     return drivers
  // }
}
